import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createRoleFilterConfig(): FilterStringConfig {
  return {
    label: 'Role',
    icon: <RESOURCE_CORE_FIELD_ICONS.role />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
